export default __webpack_public_path__ + "static/coverletter-min-c2a33c2ae87aabcb09d4e79da2ae169c.pdf";